module.exports = new __parcel__URL__("report-control-avp.dc825a04.svg").toString();